module.exports = __webpack_public_path__ + "static/media/sylvando-on.ee554b7c.png";